import { render, staticRenderFns } from "./VerificationLetter.vue?vue&type=template&id=37042c26&"
import script from "./VerificationLetter.vue?vue&type=script&lang=js&"
export * from "./VerificationLetter.vue?vue&type=script&lang=js&"
import style0 from "./VerificationLetter.vue?vue&type=style&index=0&id=37042c26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports